import NotificationsList from "@/components/Notifications/NotificationsList";
import useUser from "@/hooks/useUser";
import { Box, Divider, Drawer, Stack, Typography } from "@mui/material";
import { DrawerProps } from "./DrawerButton";

type NotificationDrawerProps = DrawerProps &
  Pick<
    ReturnType<typeof useUser>,
    "notificationLinks" | "notificationsLoading"
  >;
export function NotificationsDrawer({
  open,
  handleClose,
  notificationLinks,
  notificationsLoading,
}: NotificationDrawerProps) {
  return (
    <Drawer anchor="top" open={open} onClose={handleClose}>
      <Stack spacing={1} sx={{ width: "100%", padding: 2 }}>
        <Typography variant="subtitle1">Notifications</Typography>
        <Divider />
        <Box sx={{ maxHeight: "calc(100vh - 120px)", overflowY: "auto" }}>
          <NotificationsList
            notificationLinks={notificationLinks}
            loading={notificationsLoading}
          />
        </Box>
      </Stack>
    </Drawer>
  );
}
